<template>
    <div class="content-body customers-wrapper transaction-history">
        <b-row>
        <b-col v-for="statistic in statistics"  :key="statistic.display" sm="6" md="3" class="mb-5">
                <stat-card
                    :icon="statistic.icon"
                    :note="statistic.note"
                    :value="statistic.value"
                    :title="statistic.display"
                    :icon-bg-color="statistic.iconBgColor"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <em class="icon-calendar"></em>
                    </b-input-group>
                    <datepicker
                        :config="dateRangeConfig">
                    </datepicker>
                </b-input-group>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input placeholder="Search"
                                      v-model="searchString"
                                      @keyup.enter="search(true)">
                        </b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append">
                            <b-dropdown-item v-for="(category, index) in categories" :value="index" @click="searchOption(index)" :key="index">
                                {{ category}}
                                <em v-if="selectedSearchOption ==  index" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                </em>
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button
                            slot="append"
                            variant="primary"
                            class="h-100"
                            @click.self="search(true)"
                            :disabled="searchString == ''">
                            Search
                        </b-button>
                    </b-input-group>
                </div>
            </b-col>
            <b-col md="6" class="text-left text-md-right">
                <span class="csv-tooltip">
                    CSV <b-link class="template-button" :href="csvUrl">(Template)</b-link>
                    <b-btn variant="ghost" v-b-popover.hover="'Import or export list of your customers in excel CSV format'" title="">
                        <em class="ic-tooltip" id="csv"></em>
                    </b-btn>
                </span>
                <b-form-file
                    v-model="importCsv"
                    hidden
                    accept=".csv"
                    ref="importCsv">
                </b-form-file>
                <b-button
                    class="mr-3"
                    variant="tertiary btn-table-import-activation-key"
                    @click="openModal">
                    Import
                </b-button>
                <b-button variant="tertiary btn-table-import-activation-key" @click="exportHistory">Export</b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table
                    show-empty
                    :items="isSearchType ? [] : histories"
                    :empty-text="(loading) ? 'Loading data' : emptyText"
                    :fields="use_table_fields"
                    :current-page="currentPage"
                    responsive
                >
                    <template slot="is_guest" slot-scope="data">
                        <template v-if="data.value">
                            <img src="@/assets/images/check_circle_filled_green.png" style="height: 20px; width: 20px;" alt="Check" />
                        </template>
                    </template>
                    <template slot="status">
                        <span class="complete-status">
                            Completed
                        </span>
                    </template>
                    <template slot="date" slot-scope="data">
                        {{ data.item.transaction_date + ' ' + data.item.transaction_time }}
                    </template>
                    <template slot="mobile" slot-scope="data">
                        {{ data.value != null ? '0' + data.value : "" }}
                    </template>
                    <template slot="amount" slot-scope="data">
                        <em class="icon-peso"></em> {{ data.value | currency }}
                    </template>
                    <template slot="points" slot-scope="data">
                        <em class="icon-points"></em> {{ data.value }}
                    </template>
                    <template slot="reward" slot-scope="data">
                        <em class="icon-rewards"></em> {{ data.value }}
                    </template>
                    <template slot="membership_id" slot-scope="data">
                        {{ data.value == '' || data.value == null ? 'N/A' : data.value }}
                    </template>
                    <template slot="card_no" slot-scope="data">
                        {{ data.value == '' || data.value == null ? 'N/A' : data.value }}
                    </template>
                    <template slot="company_code" slot-scope="data">
                        {{ data.value == '' || data.value == null ? 'Not Available' : data.value }}
                    </template>
                </b-table>
            </div>
            <b-modal
                id="upload-file"
                title="Upload File"
                ref="uploadFileModal"
                @hide="resetScrollPosition"
                hide-footer
                centered>
                <b-container fluid id="upload-file-container">
                    <div class="modal-form">
                        <b-form class="mb-2">
                            <div id="file-input-container" class="p-3 mb-2" v-bind:class="{ 'hide-label': file != null }">
                                <b-form-file
                                    v-model="file"
                                    ref="fileinput"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    placeholder="Drop your file here or "
                                    @change="validateFile"
                                />
                            </div>
                            <div v-bind:class="{ 'd-none': file == null }" class="mb-4">
                                <div class="d-inline-block file-name-container">
                                    <img class="d-inline-block upload-file-icon" width="16" height="20" src="@/assets/images/icons/ic-upload-file.svg" alt="">
                                    <div class="ml-2 d-inline-block upload-file-name" v-if="file != null">
                                        {{ file.name }}
                                    </div>
                                </div>
                                <div class="d-inline-block cancel-file-upload-container">
                                    <span>{{ formatBytes(file) }}</span>
                                    <img width="15" height="15" src="@/assets/images/icons/cancel-file-upload.svg" alt="" @click="cancelFileUpload()" class="cancel-file-upload-icon">
                                </div>
                            </div>
                            <b-form-group
                                :invalid-feedback="errorMessage('file')"
                                :state="validationState('file')"
                            >
                            </b-form-group>
                            <b-form-group
                                label="Points Mechanics"
                                label-for="ponts"
                                class="mb-4"
                                :invalid-feedback="errorMessage('points_mechanic')"
                                :state="validationState('points_mechanic')"
                            >
                                <b-form-select v-model="pointsMechanic">
                                    <option v-for="(pointsMechanics, index) in pointsMechanicsList" :key="index" :value="pointsMechanics.uuid">
                                        {{ pointsMechanics.name }}
                                    </option>
                                </b-form-select>
                            </b-form-group>
                            <b-form-group
                                label="Brand and Branch"
                                class="mb-0"
                            >
                            </b-form-group>
                            <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab" style="background: #ffffff;">
                                    <b-row no-gutters>
                                        <b-col>
                                            <template v-if="selectedBranchOption == null">
                                                <span>Please select Brand/Branch</span>
                                            </template >
                                            <template v-else-if="selectedBranchOption == 'Not Applicable'">
                                                <span>Not Applicable</span>
                                            </template>
                                            <template v-else>
                                                {{ brandBranchName }}
                                            </template>
                                        </b-col>
                                        <b-col cols="1">
                                            <div
                                                v-b-toggle="'accordion'"
                                                class="action-button text-right"
                                            >
                                                <img
                                                    src="@/assets/images/icons/collapse.svg"
                                                    alt="Collapsed Icon"
                                                    class="d-inline-block mr-2 when-closed"
                                                    style="width: 14px; height: 14px;"
                                                />
                                                <img
                                                    src="@/assets/images/icons/expand.svg"
                                                    alt="Expand Icon"
                                                    class="d-inline-block mr-2 when-opened"
                                                    style="width: 14px; height: 14px;"
                                                />
                                            </div>

                                        </b-col>
                                    </b-row>
                                </b-card-header>
                                <b-collapse id='accordion' accordion="accordion" role="tabpanel" v-model="showCollapse">
                                    <b-card-body class="p-0">
                                        <b-input-group class="d-none">
                                            <b-input-group
                                                slot="prepend"
                                                class="border px-2 d-flex align-items-center"
                                            >
                                                <img
                                                    src="@/assets/images/actions/search.svg"
                                                    alt="Search Icon"
                                                    style="width: 24px; height: 24px;"
                                                />
                                            </b-input-group>
                                            <b-form-input
                                                placeholder="Search"
                                                style="border-radius: 0px; border-right: 0px; border-top: 0px;"
                                            ></b-form-input>
                                        </b-input-group>
                                        <div
                                            id="brandBranchList"
                                            class="p-0"
                                            style="height: 146px; overflow-y: scroll;"
                                        >
                                            <b-form-radio-group v-model="selectedBranchOption" stacked :name="'radioOpenions'">
                                            <div class="p-2">
                                                <b-form-radio
                                                    value="Not Applicable"
                                                >
                                                    Not Applicable
                                                </b-form-radio>
                                            </div>
                                            <b-card
                                                no-body
                                                style="border: 0px;"
                                                v-for="(brand, index) in brands"
                                                :key="`brand-${index}`"
                                            >
                                                <b-card-header header-tag="header" class="p-1" role="tab">
                                                    <b-row no-gutters>
                                                        <b-col>
                                                            {{ brand.name }}
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <div
                                                                v-b-toggle="'brand-ccordion' + index"
                                                                class="action-button text-right"
                                                            >
                                                                <img
                                                                    src="@/assets/images/icons/collapse.svg"
                                                                    alt="Collapsed Icon"
                                                                    class="d-inline-block mr-2 when-closed"
                                                                    style="width: 14px; height: 14px;"
                                                                />
                                                                <img
                                                                    src="@/assets/images/icons/expand.svg"
                                                                    alt="Expand Icon"
                                                                    class="d-inline-block mr-2 when-opened"
                                                                    style="width: 14px; height: 14px;"
                                                                />
                                                            </div>

                                                        </b-col>
                                                    </b-row>
                                                </b-card-header>
                                                <b-collapse :id="'brand-ccordion' + index" accordion="brand-accordion" role="tabpanel">
                                                    <b-card-body class="p-2">

                                                            <b-form-radio
                                                                @change="getBrandBranchNames(brand.name.trim() + ' - ' + branch.name.trim(), brand.uuid, branch.uuid)"
                                                                v-for="(branch, branchIndex) in branchOptions.filter(branch => branch.brand_uuid === brand.uuid)" :key="branchIndex"
                                                                :value="branch.uuid"
                                                            >
                                                                {{ branch.name }}
                                                            </b-form-radio>

                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                            </b-form-radio-group>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </b-form>
                        <img class="d-inline-block upload-file-folder-icon" width="42" height="42" src="@/assets/images/icons/ic-folder.svg" alt="">
                        <label class="shown-label" v-bind:class="{ 'd-none': file == null }">Drop your file here or <span>browse</span></label>
                        <hr>
                        <b-row no-gutters>
                            <b-col cols="2">
                                <switches
                                    theme="custom"
                                    v-model="is_sms"
                                    color="primary"
                                    type-bold="true"
                                    text-enabled="On"
                                    text-disabled="Off"
                                    style="top: -26px;"
                                >
                                </switches>
                            </b-col>
                            <b-col >
                                <b-form-group
                                    label="Send via SMS"
                                    class="secondary-label"
                                >
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row no-gutters style="margin-top: -15px;">
                            <b-col cols="2">
                                <switches
                                    theme="custom"
                                    v-model="is_in_app"
                                    color="primary"
                                    type-bold="true"
                                    text-enabled="On"
                                    text-disabled="Off"
                                    style="top: -26px;"
                                >
                                </switches>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Send via In-App Message"
                                    class="secondary-label"
                                >
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-btn id="upload-file-button" variant="primary" v-bind:disabled="loading || file == null || selectedBranchOption == null || !!errors" @click="uploadFile" class="btn-block mx-auto">
                            <template v-if="loading">
                                Uploading...
                            </template>
                            <template v-else>
                                Upload File
                            </template>
                        </b-btn>
                    </div>
                </b-container>
            </b-modal>
        </div>
        <div>
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">{{ currentFirstItem }}-{{ currentLastItem }} of {{ maxPage}} pages</span>
                        <b-pagination
                            hide-goto-end-buttons
                            align="left"
                            size="md"
                            :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
                            :limit="(totalPerPage > 0 ) ? 3 : 1"
                            :per-page="totalPerPage"
                            :value="currentPage"
                            @change="paginate"
                            class="custom-pagination-arrow-only mb-0 ml-2">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="notification-success-import">
            <notifications width="445px" style="left: 225 px;" classes="notif-import" group="success-import" position="bottom left"/>
        </div>
        <div class="notification-upload-import">
            <notifications width="445px" classes="upload-import" group="uploading-import" position="bottom right"/>
        </div>
    </div>
</template>

<script>
import "../../plugins/vue-currency-filter";
import Datepicker from "vue-bulma-datepicker";
import StatCard from "@/components/common/StatCard.vue";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import Switches from "vue-switches";
import moment from "moment";

export default {
    name: "transaction-history",
    components: {
        Datepicker,
        Switches,
        StatCard
    },
    data() {
        return {
            showCollapse: false,
            selectedBranchOption: null,
            brandBranchName: "",
            brandUuid: "",
            branchUuid: "",
            is_sms: false,
            is_in_app: false,
            env: process.env.VUE_APP_MODE,
            csvUrl: "",
            baseUrl: process.env.VUE_APP_API,
            interval: null,
            perPage: 25,
            value: 0,
            totalRows: 1,
            file: null,
            filename: "",
            pointsMechanic: null,
            importInProgressUuids: [],
            importCompleteUuids: [],
            json_fields: {
                "First Name": "first_name",
                "Last Name": "last_name",
                "Mobile Number": "mobile_number",
                Email: "email",
                Birthdate: "birthdate",
                Gender: "gender",
                "Membership ID": "membership_id"
            },
            json_data: [
                {
                    first_name: " ",
                    last_name: " ",
                    mobile_number: " ",
                    email: " ",
                    birthdate: " ",
                    gender: " ",
                    membership_id: " "
                }
            ],
            pointsMechanicsOptions: [
                {
                    value: "Standard",
                    text: "Standard"
                },
                {
                    value: "Christmas Bonus",
                    text: "Christmas Bonus"
                },
                {
                    value: "Gold Tier",
                    text: "Gold Tier"
                },
                {
                    value: "Diamond Tier",
                    text: "Diamond Tier"
                }
            ],
            importCsv: null,
            fields: [
                {
                    key: "created_at",
                    label: "Date & Time",
                    sortable: true
                },
                {
                    key: "customer_name",
                    label: "Customer Name",
                    sortable: true
                },
                {
                    key: "membership_id",
                    label: "Membership ID",
                    sortable: true
                },
                {
                    key: "is_guest",
                    label: "Guest",
                    sortable: true
                },

                {
                    key: "mobile",
                    label: "Mobile Number",
                    sortable: true
                },
                {
                    key: "registration_date",
                    label: "Registration Date",
                    sortable: true
                },
                {
                    key: "points_mechanic",
                    label: "Points Mechanics",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true
                },
                {
                    key: "details",
                    label: "Transaction ID",
                    sortable: true
                },
                {
                    key: "transaction_type",
                    sortable: true
                },
                {
                    key: "amount",
                    label: "Transaction Amount",
                    sortable: true
                },
                {
                    key: "points",
                    label: "Points Earned",
                    sortable: true
                },
                {
                    key: "employee_id",
                    label: "Employee ID",
                    sortable: true
                },
                {
                    key: "employee_name",
                    label: "Employee Name",
                    sortable: true
                },
                {
                    key: "employee_brand",
                    label: "Brand",
                    sortable: true
                },
                {
                    key: "employee_branch",
                    label: "Branch",
                    sortable: true
                },
                {
                    key: "reward",
                    label: "Reward Redeemed",
                    sortable: true
                },
                {
                    key: "price",
                    label: "Reward Price",
                    sortable: true
                },
                // {
                //     key: "refund_request_date",
                //     label: "Date and Time of Refund Request",
                //     sortable: true,
                //     formatter: () => {
                //         return moment().format("YYYY-MM-DD HH:mm:ss");
                //     }
                // },
                // {
                //     key: "refund_request",
                //     label: "Requested the Refund",
                //     sortable: true,
                //     formatter: () => {
                //         return "Customer";
                //     }
                // },
                // {
                //     key: "refund_sent_date",
                //     label: "Date and Time Refund Sent",
                //     sortable: true,
                //     formatter: () => {
                //         return moment().format("YYYY-MM-DD HH:mm:ss");
                //     }
                // }
            ],
            generikaFields: [
                {
                    key: "created_at",
                    label: "Date & Time",
                    sortable: true
                },
                {
                    key: "customer_name",
                    label: "Customer Name",
                    sortable: true
                },
                {
                    key: "membership_id",
                    label: "Membership ID",
                    sortable: true
                },
                {
                    key: "is_guest",
                    label: "Guest",
                    sortable: true
                },
                {
                    key: "details",
                    label: "Transaction ID",
                    sortable: true
                },
                {
                    key: "transaction_type",
                    sortable: true
                },
                {
                    key: "amount",
                    label: "Transaction Amount",
                    sortable: true
                },
                {
                    key: "points",
                    label: "Points Earned",
                    sortable: true
                },
                {
                    key: "medpadala_code",
                    label: "MEDPadala Code",
                    sortable: true
                },
                {
                    key: "medpadala_amount",
                    label: "MEDPadala Amount used",
                    sortable: true
                },
                {
                    key: "employee_id",
                    label: "Employee ID",
                    sortable: true
                },
                {
                    key: "employee_name",
                    label: "Employee Name",
                    sortable: true
                },
                {
                    key: "employee_brand",
                    label: "Brand",
                    sortable: true
                },
                {
                    key: "employee_branch",
                    label: "Branch",
                    sortable: true
                },
                {
                    key: "reward",
                    label: "Reward Redeemed",
                    sortable: true
                },
                {
                    key: "price",
                    label: "Reward Price",
                    sortable: true
                },
                {
                    key: "company_code",
                    label: "Company Code",
                    sortable: true
                }
            ],
            tindahanClubAccountFields: [
                {
                    key: "date",
                    label: "Date & Time",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Customer Name",
                    sortable: true
                },
                {
                    key: "membership_id",
                    label: "Membership ID",
                    sortable: true
                },
                {
                    key: "is_guest",
                    label: "Guest",
                    sortable: true
                },
                {
                    key: "details",
                    label: "Transaction ID",
                    sortable: true
                },
                {
                    key: "transaction_type",
                    sortable: true
                },
                {
                    key: "amount",
                    label: "Transaction Amount",
                    sortable: true
                },
                {
                    key: "points",
                    label: "Points Earned",
                    sortable: true
                },
                {
                    key: "employee_id",
                    label: "Employee ID",
                    sortable: true
                },
                {
                    key: "employee_name",
                    label: "Employee Name",
                    sortable: true
                },
                {
                    key: "employee_brand",
                    label: "Brand",
                    sortable: true
                },
                {
                    key: "tagged_skus",
                    label: "Brand SKUs",
                    sortable: true
                },
                {
                    key: "employee_branch",
                    label: "Branch",
                    sortable: true
                },
                {
                    key: "reward",
                    label: "Reward Redeemed",
                    sortable: true
                },
                {
                    key: "price",
                    label: "Reward Price",
                    sortable: true
                },
                {
                    key: "company_code",
                    label: "Company Code",
                    sortable: true
                }
            ],
            marketPlaceFields: [
                {
                    key: "date",
                    label: "Date & Time",
                    sortable: true
                },
                {
                    key: "details",
                    label: "Transaction ID",
                    sortable: true
                },
                {
                    key: "employee_id",
                    label: "Employee ID",
                    sortable: true
                },
                {
                    key: "employee_name",
                    label: "Employee Name",
                    sortable: true
                },
                {
                    key: "employee_brand",
                    label: "Brand",
                    sortable: true
                },
                {
                    key: "employee_branch",
                    label: "Branch",
                    sortable: true
                },
                {
                    key: "reward",
                    label: "Reward Redeemed",
                    sortable: true
                },
                {
                    key: "price",
                    label: "Reward Price",
                    sortable: true
                },
                {
                    key: "company_code",
                    label: "Company Code",
                    sortable: true
                }
            ],
            searchString: "",
            selectedSearchOption: "0",
            selectedDateOption: [],
            range: null,
            emptyText: "No data to show",
            isSearchType: false,
            items: null,
            keyAccountsUuid: {
                local: [
                    // "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                    "5f34dbaf-93e0-46bd-9779-777b7cfccc30" // generika
                ],
                Development: [
                    // "8e9bc0ba-aa25-4c75-96d5-b16703916b35", //estore
                ],
                Canary: [
                    // "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                    "5f34dbaf-93e0-46bd-9779-777b7cfccc30" // generika
                ],
                Staging: [
                    "90dd82f7-0e39-430c-9647-cdf7e3741708" // generika
                ],
                Release: [
                    // "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                    "e07df259-aae6-4ea8-b507-b07f08131727" // generika
                ],
                Production: [
                    // "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                    "e07df259-aae6-4ea8-b507-b07f08131727" // generika
                ]
            },
            keyAccount: null,
            use_table_fields: []
        };
    },
    computed: {
        ...mapState("transactions", [
            "errors",
            "histories",
            "uuidsWithKeyAccounts",
            "importUuid", // Specific UUID
            "importUuids",
            "nextPage",
            "prevPage",
            "maxPage",
            "currentPage",
            "totalPerPage",
            "searching",
            "categories",
            "loading",
            "currentFirstItem",
            "currentLastItem",
            "customerNames",
            "all_uuids",
            "summaryCount"
        ]),
        ...mapState("auth", ["enabledTopUps", "planId", "user"]),
        ...mapState("customers", ["merchantUuid"]),
        ...mapState("points", ["pointsMechanicsList"]),
        ...mapState("merchants", {
            meta: state => state.meta,
            merchantLoading: state => state.loading
        }),
        ...mapState("branches", {
            branchOptions: state => state.branchOptions,
            branchLoading: state => state.loading
        }),
        ...mapState("brands", {
            brands: state => state.brands,
            brandLoading: state => state.loading
        }),
        ...mapState("analytics", ["isSegmentAnalyticsReady"]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        _this.selectedDate(selectedDates);
                        _this.range = selectedDates;
                    }
                };
            }
        },
        statistics() {
            const year = this.summaryCount.year
                ? this.summaryCount.year
                : new Date().getFullYear();

            const month = this.summaryCount.month
                ? this.summaryCount.month
                : new Date().toLocaleString("default", {
                      month: "long"
                  });

            const note = this.summaryCount.created_at
                ? `Data as of ${this.$moment(
                      this.summaryCount.created_at
                  ).format(
                      "YYYY/MM/DD, hh:mm a"
                  )}. For latest reading, we advise checking again on the next hour.`
                : "";

            return [
                {
                    note,
                    display: `${year} Earn Transactions`,
                    value:
                        "earn_yearly_count" in this.summaryCount
                            ? this.summaryCount.earn_yearly_count
                            : "-",
                    iconBgColor: "rgba(255, 138, 0, 0.08)",
                    icon: "yearly_earn_transaction_count.svg"
                },
                {
                    note,
                    display: `${month} Earn Transactions`,
                    value:
                        "earn_monthly_count" in this.summaryCount
                            ? this.summaryCount.earn_monthly_count
                            : "-",
                    iconBgColor: "rgba(255, 138, 0, 0.08)",
                    icon: "monthly_earn_transaction_count.svg"
                },
                {
                    note,
                    display: `${year} Redeem Transactions`,
                    value:
                        "redeem_yearly_count" in this.summaryCount
                            ? this.summaryCount.redeem_yearly_count
                            : "-",
                    iconBgColor: "rgba(81, 130, 255, 0.08)",
                    icon: "yearly_redeem_transaction_count.svg"
                },
                {
                    note,
                    display: `${month} Redeem Transactions`,
                    value:
                        "redeem_monthly_count" in this.summaryCount
                            ? this.summaryCount.redeem_monthly_count
                            : "-",
                    iconBgColor: "rgba(81, 130, 255, 0.08)",
                    icon: "monthly_redeem_transaction_count.svg"
                }
            ];
        },
        ...mapGetters("accountProfile", ["planExecutions"]),
        isEstoreExecutionOnly: {
            get() {
                let status = false;
                Object.keys(this.planExecutions).forEach(key => {
                    if (key === 'enable_estore' && this.planExecutions[key]) status = true;
                    else if (key !== 'enable_estore' && this.planExecutions[key]) status = false;
                });
                return status;
            },
            set(status) {
                return status;
            }
        }
    },
    created() {
        this.initPage();
        this.isPrivilegeCard();
        setTimeout(() => this.initTableFields(), 300);
    },
    methods: {
        validateFile(e) {
            const file = e.target.files[0];
            this.filename = file.name;

            this.$store.commit("transactions/errors", null);

            if (
                !["application/vnd.ms-excel", ".csv", "text/csv"].includes(
                    file.type
                )
            ) {
                this.$store.commit("transactions/errors", {
                    errors: {
                        file: "Invalid file format, only CSV file is accepted."
                    }
                });
            }
        },
        async updateMeta() {
            let payload = {
                merchant_uuid: this.user.merchant_uuid,
                meta_key: "import_transaction_history_notifications",
                value: {
                    is_sms: this.is_sms == true ? 1 : 0,
                    is_in_app: this.is_in_app == true ? 1 : 0
                }
            };

            await this.$store.dispatch("merchants/updateMeta", payload);
        },
        generateCsvUrl() {
            this.csvUrl =
                this.baseUrl +
                "transactions-service/transaction/merchant/template";
        },
        formatData() {
            if (this.histories != null) {
                let customers = this.histories.map(obj => {
                    let customer = {};
                    customer["date"] = obj.created_at;
                    customer["card_no"] = obj.card_no;
                    customer["customer_name"] = obj.customer_name;
                    customer["mobile"] = obj.customer_name;
                    customer["registration_date"] = "";
                    customer["points_mechanic"] = obj.points_mechanic;
                    customer["membership_id"] = obj.membership_id;
                    customer["is_guest"] = obj.is_guest;
                    customer["details"] = obj.details;
                    customer["transaction_type"] = obj.transaction_type;
                    customer["amount"] = obj.amount;
                    customer["points"] = obj.points;
                    customer["employee_id"] = obj.employee_id;
                    customer["employee_name"] = obj.employee_name;
                    customer["employee_brand"] = obj.employee_brand;
                    customer["employee_branch"] = obj.employee_branch;
                    customer["reward"] = obj.reward;
                    customer["price"] = obj.price;
                    customer["company_code"] = obj.company_code;
                    return customer;
                });
                this.items = customers;
            }
        },
        browseCSV: function() {
            this.$refs["importCsv"].$el.children[0].click();
        },
        cancelFileUpload() {
            this.$refs.fileinput.reset();
            this.file = null;
            this.filename = "";
            this.$store.commit("transactions/errors", null);
        },
        async initPage() {
            // await this.getCustomerUuids();
            this.generateCsvUrl();
            await this.getPointsMechanicsList();
            await this.getHistory(1);
            await this.getCategories();
            this.$store.dispatch("brands/getBrands");
            this.$store.dispatch("branches/getBranches");

            this.$store.dispatch("transactions/getSummaryCount");

            //Check  if Estore or Generika
            this.keyAccount = this.keyAccountsUuid[
                process.env.VUE_APP_MODE
            ].find(uuid => uuid == this.merchantUuid);
        },
        async getHistory(page) {
            let range = null;
            if (this.range != null) range = this.getRange(this.range);
            let param = {
                apiFields: {
                    category: this.selectedSearchOption,
                    keyword: this.searchString,
                    filter_date: range
                },
                page: page
            };
            await this.$store
                .dispatch("transactions/getHistory", param);
        },
        getCategories() {
            this.$store.dispatch("transactions/getCategories");
        },
        getCustomerUuids() {
            this.$store.dispatch("transactions/getCustomerUuids");
        },
        getCSVTemplate() {
            this.$store.dispatch("transactions/getCSVTemplate");
        },
        getPointsMechanicsList() {
            this.$store.dispatch("points/getPointsMechanicsList");
        },
        getSearchable() {
            let textSearch = [];

            textSearch.push(this.searchString);

            if (
                this.selectedSearchOption == 0 ||
                this.selectedSearchOption == 1
            ) {
                let _this = this;

                _.forEach(this.customerNames, function(value) {
                    let name = value.name.toLowerCase();

                    if (name.includes(_this.searchString.toLowerCase())) {
                        textSearch.push(value.uuid);
                    }
                });
            }

            return textSearch;
        },
        getSearchParams(newSearch, page) {
            // let textSearch = this.getSearchable();
            let range = null;

            if (this.range != null) range = this.getRange(this.range);

            let param = {
                apiFields: {
                    category: this.selectedSearchOption,
                    keyword: this.searchString,
                    filter_date: range
                },
                page: newSearch === true ? 1 : page
            };

            console.log(param);
            
            return param;
        },
        search(newSearch, page) {
            let param = this.getSearchParams(newSearch, page);

            if (this.searchString.trim() === "") {
                return this.getHistory(1);
            }

            if (newSearch) {
                this.emptyText = "Searching...";
                this.isSearchType = true;
            }

            let _this = this;
            this.$store.dispatch("transactions/getHistory", param).then(() => {
                _this.emptyText =
                    'No Records Found for "' + _this.searchString + '"';
                _this.isSearchType = false;
            });
        },
        searchOption(value) {
            this.selectedSearchOption = value;
        },
        paginate(page) {
            if (this.range) {
                return this.filterDate(this.getRange(this.range), page);
            }

            if (this.searching) {
                return this.search(false, page);
            }

            return this.getHistory(page);
        },
        selectedDate(value) {
            let range = {};

            if (value.length == 2) {
                range = this.getRange(value);

                this.filterDate(range, this.currentPage);
            }
        },
        getRange(value) {
            this.range = value;

            let range = {
                start: this.$moment(value[0]).format("YYYY-MM-DD"),
                end: this.$moment(value[1]).format("YYYY-MM-DD")
            };

            return range;
        },
        filterDate(range, page = 1) {
            if (this.searchString.trim() !== "") {
                let param = this.getSearchParams(false, page);
                this.$store.dispatch("transactions/getHistory", param);
            } else {
                let param = {
                    apiFields: range,
                    page: page
                };

                this.$store.dispatch("transactions/filterByDateFull", param);
            }
        },
        async exportHistory() {
            let range_param =
                this.range == null ? null : this.getRange(this.range);

            let searchable =
                this.searchString == "" ? null : this.getSearchable();

            let search_param =
                searchable == null
                    ? null
                    : {
                          category: this.selectedSearchOption,
                          text: searchable
                      };

            let param = {
                filter: range_param,
                search: search_param
            };

            await this.$store.dispatch("transactions/exportHistory", param);

            if (
                !this.errors &&
                this.isSegmentAnalyticsReady
            ) {
                window.analytics.track("Export Transaction History", param);
            }
        },
        isPrivilegeCard() {
            if (this.enabledTopUps.includes("privilege_card")) {
                this.fields[2] = {
                    key: "card_no",
                    label: "Card No.",
                    sortable: true
                };
            }
        },
        async initTableFields() {
            await this.filterPointsRewardPrice();

            const tindahanClubUuid = "9f68eb5b-6a8a-43c4-b3e9-509af092c34b";
            const marketPlacePlanId = 5;

            if (this.keyAccount) this.use_table_fields = this.generikaFields;

            else if (this.user && this.user.merchant_uuid === tindahanClubUuid)
                this.use_table_fields = this.tindahanClubAccountFields;

            else if (this.planId === marketPlacePlanId) this.use_table_fields = this.marketPlaceFields;
            
            else this.use_table_fields = this.fields;
        },
        filterPointsRewardPrice() {
            const field_groups = [
                'generikaFields',
                'tindahanClubAccountFields',
                'marketPlaceFields',
                'fields'
            ];
            if (this.isEstoreExecutionOnly) {
                field_groups.forEach(group => {
                    const points_earned = this[group].find(field => field.key === 'points');
                    const reward_price = this[group].find(field => field.key === 'price');

                    _.pull(this[group], points_earned, reward_price);
                });
            }
        },
        showNotification(importStatus) {
            if (importStatus.status == "Pending") {
                if (!this.importInProgressUuids.includes(importStatus.uuid)) {
                    this.$notify({
                        id: "uploading-import" + importStatus.uuid,
                        group: "uploading-import",
                        title:
                            "<span class='uploading'>Uploading</span> <i class='icon-close'></i>",
                        duration: -10
                    });
                }
            } else if (importStatus.status == "Done") {
                this.importInProgressUuids = this.importInProgressUuids.filter(
                    uuid => uuid !== importStatus.uuid
                );
                let closeUploadNotifRef = "upload-close-" + importStatus.uuid; //  Get UUID of close button of upload notification
                if (document.getElementById(closeUploadNotifRef) != null) {
                    // Close upload notification if it's done
                    document.getElementById(closeUploadNotifRef).click();
                }
                if (!this.importCompleteUuids.includes(importStatus.uuid)) {
                    this.importCompleteUuids.push(importStatus.uuid);
                    let titleToBeShown = "";

                    if (importStatus.failed_count >= 1) {
                        titleToBeShown =
                            "<i class='icon-success'></i>" +
                            importStatus.import_message +
                            " See email. <i class='icon-close'></i>";
                    } else {
                        titleToBeShown =
                            "<i class='icon-success'></i>" +
                            importStatus.import_message +
                            "</span> <i class='icon-close-without-download-link'></i>";
                    }

                    if (
                        !this.errors &&
                        this.isSegmentAnalyticsReady
                    ) {
                        window.analytics.track("Import Transaction History", {
                            file_name: this.filename
                        });
                    }

                    this.$notify({
                        id: "success-import" + importStatus.uuid,
                        group: "success-import",
                        title: titleToBeShown,
                        duration: 1800000
                    });
                }
                //  Remove UUID from importUuids
                this.$store.dispatch(
                    "transactions/removeUuidFromiImportUuids",
                    importStatus.uuid
                );
                // Refresh the table after uploading
                this.initPage();
            }
        },
        async checkInitialImportStatus() {
            let _this = this;
            await this.$store
                .dispatch("transactions/getImportsStatus", _this.importUuid)
                .then(function(importStatus) {
                    if (importStatus.import.status == "Pending") {
                        _this.importInProgressUuids.push(
                            importStatus.import.uuid
                        );
                        _this.$notify({
                            id: importStatus.import.status.uuid,
                            group: "uploading-import",
                            title:
                                "<div class='lds-circle'><div></div></div> <span class='uploading'>Uploading</span> <i class='icon-close' id='upload-close-" +
                                importStatus.import.uuid +
                                "' ></i>",
                            duration: -10
                        });
                    }
                });
        },
        async checkImportStatus() {
            if (this.importUuids.length > 0) {
                this.interval = window.setInterval(() => {
                    for (
                        let index = 0;
                        index < this.importUuids.length;
                        index++
                    ) {
                        let _this = this;
                        const element = this.importUuids[index];
                        this.$store
                            .dispatch("transactions/getImportsStatus", element)
                            .then(function(data) {
                                _this.showNotification(data.import);
                            });
                    }
                }, 5000);
            } else {
                clearInterval(this.interval);
            }
        },
        async uploadFile() {
            this.$store.dispatch("transactions/resetErrors");

            const fileInBase64 = this.file
                ? await this.getBase64(this.file)
                : null;

            let param = {
                file: fileInBase64 ? fileInBase64.split("base64,").pop() : null,
                points_mechanic_uuid: this.pointsMechanic,
                send_notification: {
                    sms: this.is_sms == true ? 1 : 0,
                    "in-app": this.is_in_app == true ? 1 : 0
                }
            };

            if (this.selectedBranchOption !== "Not Applicable") {
                param.brand_branch_name = this.brandBranchName;
                param.brand_uuid = this.brandUuid;
                param.branch_uuid = this.branchUuid;
            } else {
                param.brand_branch_name = null;
                param.brand_uuid = null;
                param.branch_uuid = null;
            }

            let _this = this;
            await this.$store
                .dispatch("transactions/importTransactions", param)
                .then(function() {
                    if (_this.errors == null) {
                        _this.checkInitialImportStatus();
                        _this.checkImportStatus();
                        _this.$refs.uploadFileModal.hide();
                        _this.$refs.fileinput.reset();
                        _this.file = null;
                        _this.pointsMechanic = null;
                        _this.is_sms = false;
                        _this.is_in_app = false;
                        _this.selectedBranchOption = null;
                    }
                });
        },
        formatBytes(file, decimals = 2) {
            if (file != null) {
                if (file.size === 0) return "0 Bytes";

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = [
                    "Bytes",
                    "KB",
                    "MB",
                    "GB",
                    "TB",
                    "PB",
                    "EB",
                    "ZB",
                    "YB"
                ];

                const i = Math.floor(Math.log(file.size) / Math.log(k));

                return (
                    parseFloat((file.size / Math.pow(k, i)).toFixed(dm)) +
                    " " +
                    sizes[i]
                );
            }
        },
        async getBase64(file) {
            return new Promise(function(resolve, reject) {
                const reader = new FileReader();
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        errorMessage(field) {
            if (!this.errors) return "";

            return this.errors.errors && this.errors.errors[field];
        },
        validationState(field) {
            if (!this.errors) return false;

            return this.errors.errors && this.errors.errors[field]
                ? false
                : true;
        },
        async openModal() {
            this.$store.dispatch("transactions/resetErrors");
            this.showCollapse = false;
            this.$refs.fileinput.reset();
            this.file = null;
            this.pointsMechanic = null;
            this.is_sms = false;
            this.is_in_app = false;
            this.selectedBranchOption = null;
            this.$refs.uploadFileModal.show();
        },
        getBrandBranchNames(brandBranchName, brandUuid, branchUuid) {
            this.brandBranchName = brandBranchName;
            this.brandUuid = brandUuid;
            this.branchUuid = branchUuid;
        },
        async resetScrollPosition() {
            let brandBranchListDiv = document.getElementById("brandBranchList");
            brandBranchListDiv.scrollTop = 0;
        },
        async resetMeta() {
            this.selectedBranchOption = "Not Applicable";
            let payload = {
                merchant_uuid: this.user.merchant_uuid,
                meta_key: "import_transaction_history_notifications",
                value: {
                    is_sms: 0,
                    is_in_app: 0
                }
            };

            await this.$store.dispatch("merchants/updateMeta", payload);
        }
    }
};
</script>
<style lang="scss">
.btn-primary.disabled,
.btn-primary:disabled {
    background-color: #ccc7c4;
    border-color: #ccc7c4;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none !important;
}
.customers-wrapper table th,
.customers-wrapper table td:nth-child(4) {
    text-align: center !important;
}
.lds-circle {
    top: 4px;
    position: relative;
    display: inline-block;
    transform: translateZ(1px);
}
.lds-circle > div {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 8px;
    border-radius: 50%;
    background: #ff8828;
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
@keyframes lds-circle {
    0%,
    100% {
        animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }
    0% {
        transform: rotateY(0deg);
    }
    50% {
        transform: rotateY(1800deg);
        animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }
    100% {
        transform: rotateY(3600deg);
    }
}
</style>
